/**
 * Автокомплит городов для места рождения
 * Использует бесплатный GeoNames API
 */

const GEONAMES_USERNAME = 'astromatch' // Можно использовать 'demo', но лучше зарегистрироваться

/**
 * Поиск городов по запросу
 * @param {string} query - Поисковый запрос
 * @returns {Promise<Array>} Массив городов
 */
export async function searchCities(query) {
  if (!query || query.length < 2) {
    return []
  }

  try {
    // Используем GeoNames Search API (бесплатный, требует регистрации для большего лимита)
    const url = `https://secure.geonames.org/searchJSON?q=${encodeURIComponent(query)}&maxRows=10&featureClass=P&username=${GEONAMES_USERNAME}&style=full`
    
    const response = await fetch(url)
    const data = await response.json()

    if (data.geonames && Array.isArray(data.geonames)) {
      return data.geonames.map(city => ({
        name: city.name,
        country: city.countryName,
        fullName: `${city.name}, ${city.countryName}`,
        lat: city.lat,
        lng: city.lng,
        geonameId: city.geonameId
      }))
    }

    return []
  } catch (error) {
    console.error('Error searching cities:', error)
    return []
  }
}

/**
 * Альтернативный вариант через OpenWeatherMap Geocoding API (требует API ключ)
 * Если у вас есть API ключ OpenWeatherMap, можно использовать этот вариант:
 */
/*
export async function searchCities(query) {
  if (!query || query.length < 2) {
    return []
  }

  const API_KEY = import.meta.env.VITE_OPENWEATHER_API_KEY
  if (!API_KEY) {
    console.warn('OpenWeatherMap API key not found')
    return []
  }

  try {
    const url = `https://api.openweathermap.org/geo/1.0/direct?q=${encodeURIComponent(query)}&limit=10&appid=${API_KEY}`
    const response = await fetch(url)
    const data = await response.json()

    return data.map(city => ({
      name: city.name,
      country: city.country,
      fullName: `${city.name}, ${city.country}`,
      lat: city.lat,
      lng: city.lon
    }))
  } catch (error) {
    console.error('Error searching cities:', error)
    return []
  }
}
*/
